module.exports = __webpack_public_path__ + "static/media/6.76c38246.jpg";